import { render } from "./Chart.vue?vue&type=template&id=12b936c9&scoped=true&bindings={\"title\":\"props\",\"url\":\"props\",\"label\":\"props\",\"id\":\"props\"}"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=12b936c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12b936c9"

export default script